import { Component, OnInit } from '@angular/core';
import { inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { take } from 'rxjs';

import { AdministratorCompanyCRUDService, AdministratorCompanyReadOnlySchema } from '@digitalforest/ngx-oak-api';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-company-list-page',
  templateUrl: './company-list-page.component.html',
  styleUrls: ['./company-list-page.component.scss'],
  standalone: true,
  imports: [RouterLink],
})
export class CompanyListPageComponent implements OnInit {
  administratorCompanyList: AdministratorCompanyReadOnlySchema[] = [];
  isLoading = true;

  private authService = inject(AuthService);
  private administratorCompanyCRUDService = inject(AdministratorCompanyCRUDService);

  ngOnInit(): void {
    const tokenData = this.authService.decodeToken();

    if (!tokenData?.id) {
      console.error('Unable to retrieve administrator ID from token');
      this.isLoading = false;
      return;
    }

    const id = tokenData.id;

    this.administratorCompanyCRUDService
      .manageGetAllAdministratorCompaniesByAdministrator(id, undefined, undefined, undefined)
      .pipe(take(1))
      .subscribe({
        next: (value) => {
          this.administratorCompanyList = [...value].sort((a, b) => {
            const nameA = a.company_name ?? '';
            const nameB = b.company_name ?? '';

            return nameA.localeCompare(nameB);
          });
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  getRouterLink(companyId: number) {
    return [...environment.companyListRouterLink, companyId];
  }
}
